import type { SxProps, Theme } from '@mui/material/styles';

/** Glass panel — #21232D at 80% (ContactDialog, LiveRankingsGate) */
export const CONTACT_DIALOG_BG = 'rgba(33, 35, 45, 0.8)';
/** Paper border */
export const DIALOG_BORDER = 'rgba(255, 255, 255, 0.1)';
/** Solid fill for inputs over the glass panel */
export const INPUT_FIELD_BG = '#21232D';

const INPUT_OUTLINE_WHITE = 'rgba(255, 255, 255, 0.1)';
const INPUT_OUTLINE_WHITE_HOVER = 'rgba(255, 255, 255, 0.7)';
const INPUT_OUTLINE_WHITE_FOCUS = 'rgba(255, 255, 255, 0.95)';

export const textFieldDarkSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        color: 'white',
        backgroundColor: INPUT_FIELD_BG,
        '&:hover': {
            backgroundColor: INPUT_FIELD_BG,
        },
        '&.Mui-focused': {
            backgroundColor: INPUT_FIELD_BG,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: INPUT_OUTLINE_WHITE,
            borderWidth: '1px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: INPUT_OUTLINE_WHITE_HOVER,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: INPUT_OUTLINE_WHITE_FOCUS,
            borderWidth: '1px',
        },
        '&.Mui-disabled': {
            color: 'rgba(255,255,255,0.4)',
            backgroundColor: INPUT_FIELD_BG,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255,255,255,0.22)',
            },
        },
    },
    '& .MuiInputLabel-root': {
        color: 'rgba(255,255,255,0.65)',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'rgba(255,255,255,0.95)',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: 'rgba(255,255,255,0.35)',
    },
    '& .MuiOutlinedInput-input::placeholder': {
        color: 'rgba(255,255,255,0.35)',
        opacity: 1,
    },
};

/**
 * Dark TextField + field-level validation: red outline and helper text below the input
 * (same pattern for all fields on a glass panel).
 */
export const textFieldDarkFieldErrorSx: SxProps<Theme> = {
    ...textFieldDarkSx,
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(239, 83, 80, 0.85)',
    },
    '& .MuiInputLabel-root.Mui-error': {
        color: '#ffab91',
    },
    '& .MuiFormHelperText-root': {
        mx: 0,
        mt: 1,
    },
    '& .MuiFormHelperText-root.Mui-error': {
        color: '#ffab91',
    },
};

/** `PaperProps.sx` for glass dialogs */
export const glassDialogPaperSx: SxProps<Theme> = {
    borderRadius: '16px',
    p: 1,
    backgroundColor: CONTACT_DIALOG_BG,
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: `1px solid ${DIALOG_BORDER}`,
    boxShadow: '0 8px 32px rgba(0,0,0,0.45)',
};
